import { createEvent } from 'effector';

export const getUser = createEvent();
